/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_fds/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    // Local login is retired — sign in on the main FDS app. next=/labor/scheduling
    // makes the backend SSO the user straight back into this scheduler app
    // after login (the old '/login' path doesn't exist on the v2 backend and
    // left users stranded on /auth/login?next=%2Flogin).
    window.location.replace(
      process.env.REACT_APP_OLD_FLASK_APP_URL +
        '/auth/login?next=' +
        encodeURIComponent('/labor/scheduling')
    )
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return <div className='d-flex flex-column flex-lg-row flex-column-fluid h-700px'></div>
}

export {AuthLayout}
